import React from 'react';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import { FiHome, FiLogOut } from "react-icons/fi";
import { IoNewspaperOutline } from "react-icons/io5";
import { AiOutlineReload } from "react-icons/ai";
import { MdOutlineQuiz } from "react-icons/md";
import { FaPassport } from "react-icons/fa";

const Sidebar = ({ open, onClose }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    { label: "Dashboard", path: "/dashboard", icon: <FiHome /> },
    { label: "Previous Year Paper", path: "/dashboard/previous-year-papers", icon: <IoNewspaperOutline /> },
    { label: "Practice", path: "/dashboard/practice", icon: <AiOutlineReload className="transform scale-x-[-1]" /> },
    { label: "Free Quizzes", path: "/dashboard/free-quizzes", icon: <MdOutlineQuiz /> },
    { label: "Subscription", path: "/dashboard/subscription", icon: <FaPassport /> },
    // { label: "Prime Subscription", path: "/dashboard/prime-subscription", icon: <BsPassFill /> },
  ];

  return (
    <aside
      className={`
        fixed  
        lg:sticky 
        z-40
        top-[88px] 
        h-[calc(100vh-98px)]
        lg:h-[584px]
        left-4 lg:left-0
        w-[220px] 
        max-w-[calc(100vw-32px)]
        bg-white shadow-[0_1px_4px_rgba(0,0,0,0.25)] rounded-[10px]
        
        transform transition-transform duration-300
        ${open ? "translate-x-0" : "-translate-x-[120%]"}
        lg:translate-x-0
        
        flex flex-col 
        lg:mr-7 
        overflow-y-auto lg:overflow-visible
      `}
    >

      {/* Menu Items */}
      <div className="flex flex-col ">
        {menuItems.map((item, index) => {
          const isActive = location.pathname === item.path;
          return (
            <Link key={item.label} to={item.path} onClick={onClose}>
              <div
                className="flex items-center transition-all duration-200"
                style={{
                  height: '48px',
                  padding: '14px 16px',
                  gap: '10px',
                  backgroundColor: isActive ? '#E3E3E3' : 'transparent',
                  borderLeft: isActive ? '1.5px solid #E63946' : '1.5px solid transparent',
                  borderTopLeftRadius: isActive ? '4px' : '0',
                  borderBottomLeftRadius: isActive ? '4px' : '0',
                }}
              >
                <span className={`text-[18px] font-[500]  ${isActive ? 'text-[#E63946]' : 'text-[#3333333]'}`}>
                  {item.icon}
                </span>
                <span className={`text-[16px] tracking-tight leading-none font-[500] ${isActive ? 'text-[#E63946]' : 'text-[#3333333]'}`}>
                  {item.label}
                </span>
              </div>
            </Link>
          );
        })}
      </div>

      <div className="mt-auto pb-3">
        <div className="h-[1.5px] bg-[#E63946] w-full mb-2 opacity-100"></div>
        <button className="flex items-center gap-4 py-3 px-4 w-full text-[#E63946] font-bold text-[16px] hover:bg-red-50 rounded-lg transition-colors cursor-pointer"
          onClick={() => {
            localStorage.removeItem("user");
            localStorage.removeItem("profile");
            navigate("/");
          }}>
          <FiLogOut className="text-[20px]" />
          <span>Log Out</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;